(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["casa-shoppable-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('casa-shoppable-videos')) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function parseHTML(html) {
      return new DOMParser().parseFromString(html, 'text/html');
    }

    function shopRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    // A stable short name for a video file, used when Shopify gives no id.
    function videoKey(url) {
      var match = /\/([a-f0-9]{16,})[./]/i.exec(url || '');
      if (match) return match[1].slice(0, 16);
      return String(url || '').split('?')[0].split('/').pop().slice(0, 40);
    }

    // True the first time this browser reports `flag` today. This is how the
    // dashboard counts unique visitors without storing any visitor id.
    function firstToday(flag) {
      var storeKey = 'casaShoppableVideoDay';
      var now = new Date();
      var state = { d: now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate(), f: {} };
      try {
        var saved = JSON.parse(window.localStorage.getItem(storeKey));
        if (saved && saved.d === state.d && saved.f) state = saved;
      } catch (error) {}
      if (state.f[flag]) return false;
      state.f[flag] = 1;
      try {
        window.localStorage.setItem(storeKey, JSON.stringify(state));
      } catch (error) {}
      return true;
    }

    function emptyQueue() {
      return { imp: 0, uimp: 0, viewers: 0, items: {} };
    }

    class CasaShoppableVideos extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;

        this.entries = [];
        var cards = this.querySelectorAll('[data-csv-card]');
        for (var i = 0; i < cards.length; i++) {
          var card = cards[i];
          var holder = card.parentElement.querySelector('[data-csv-data]');
          try {
            var data = JSON.parse(holder.textContent);
            if (data && data.video) {
              this.entries.push({ card: card, data: data, key: String(data.id || videoKey(data.video)) });
            }
          } catch (error) {
            card.parentElement.hidden = true;
          }
        }
        if (!this.entries.length) return;

        this.rail = this.querySelector('[data-csv-rail]');
        this.dialog = this.querySelector('dialog');
        this.stage = this.querySelector('[data-csv-stage]');
        this.video = this.querySelector('[data-csv-video]');
        this.bar = this.querySelector('[data-csv-bar]');
        this.captionEl = this.querySelector('[data-csv-caption]');
        this.panel = this.querySelector('[data-csv-panel]');
        this.imgEl = this.querySelector('[data-csv-img]');
        this.titleEl = this.querySelector('[data-csv-title]');
        this.priceEl = this.querySelector('[data-csv-price]');
        this.compareEl = this.querySelector('[data-csv-compare]');
        this.linkEl = this.querySelector('[data-csv-link]');
        this.selectEl = this.querySelector('[data-csv-select]');
        this.addBtn = this.querySelector('[data-csv-add]');
        this.statusEl = this.querySelector('[data-csv-status]');
        this.statusText = this.querySelector('[data-csv-status-text]');
        this.cartLink = this.querySelector('[data-csv-cart-link]');
        this.muteBtn = this.querySelector('[data-csv-mute]');
        this.toggleBtn = this.querySelector('[data-csv-toggle]');
        this.prevBtn = this.querySelector('[data-csv-prev]');
        this.nextBtn = this.querySelector('[data-csv-next]');

        this.index = 0;
        this.busy = false;
        this.product = null;
        this.visible = new Set();
        this.muted = this.dataset.startSound !== 'true';

        // Analytics: counts wait in `queue` and go out in small batches.
        var inEditor = !!(window.Shopify && window.Shopify.designMode);
        var trackUrl = (this.dataset.trackUrl || '').trim();
        this.trackUrl = !inEditor && /^https:\/\//i.test(trackUrl) ? trackUrl : '';
        this.inEditor = inEditor;
        this.queue = emptyQueue();
        this.playState = null;

        this.bindRail();
        this.bindPlayer();
        this.setupPreviews();
        this.setupTracking();
      }

      disconnectedCallback() {
        if (this.previewObserver) this.previewObserver.disconnect();
        if (this.viewObserver) this.viewObserver.disconnect();
        if (this.onResize) window.removeEventListener('resize', this.onResize);
        if (this.onHide) {
          document.removeEventListener('visibilitychange', this.onHide);
          window.removeEventListener('pagehide', this.onHide);
        }
        document.documentElement.classList.remove('csv-lock');
        this.ready = false;
      }

      /* ---------- Analytics ---------- */

      setupTracking() {
        var self = this;

        // A "view" is counted once per page load, when half the row is on screen.
        if ('IntersectionObserver' in window) {
          this.viewObserver = new IntersectionObserver(
            function (changes) {
              var seen = changes.some(function (change) { return change.isIntersecting; });
              if (!seen) return;
              self.viewObserver.disconnect();
              self.queue.imp = 1;
              self.queue.uimp = firstToday('view') ? 1 : 0;
              self.flush();
            },
            { threshold: 0.5 }
          );
          this.viewObserver.observe(this.rail);
        }

        // Send whatever is waiting when the shopper leaves or switches tab.
        this.onHide = function (event) {
          if (event.type === 'visibilitychange' && document.visibilityState !== 'hidden') return;
          self.harvest();
          self.flush();
        };
        document.addEventListener('visibilitychange', this.onHide);
        window.addEventListener('pagehide', this.onHide);
      }

      statsFor(entry) {
        var items = this.queue.items;
        if (!items[entry.key]) {
          items[entry.key] = { entry: entry, opens: 0, uopens: 0, watch: 0, q25: 0, q50: 0, q75: 0, done: 0, atc: 0 };
        }
        return items[entry.key];
      }

      // Starts measuring the video now on screen (closing out the previous one).
      startPlay() {
        this.harvest();
        this.playState = {
          entry: this.entries[this.index],
          started: false,
          counted: false,
          watch: 0,
          sent: 0,
          last: null,
          max: 0,
          marks: {},
        };
      }

      // Moves what the current play has earned since the last harvest into the queue.
      harvest() {
        var play = this.playState;
        if (!play || !play.started) return;
        var stats = this.statsFor(play.entry);

        if (!play.counted) {
          play.counted = true;
          stats.opens += 1;
          if (firstToday('video:' + play.entry.key)) stats.uopens += 1;
          if (firstToday('viewer')) this.queue.viewers += 1;
        }
        if (play.watch > play.sent) {
          stats.watch += play.watch - play.sent;
          play.sent = play.watch;
        }
        [['q25', 0.25], ['q50', 0.5], ['q75', 0.75], ['done', 0.95]].forEach(function (mark) {
          if (play.max >= mark[1] && !play.marks[mark[0]]) {
            play.marks[mark[0]] = 1;
            stats[mark[0]] += 1;
          }
        });
      }

      flush() {
        var queue = this.queue;
        var items = [];
        Object.keys(queue.items).forEach(function (key) {
          var stats = queue.items[key];
          var active = stats.opens || stats.q25 || stats.q50 || stats.q75 || stats.done || stats.atc || stats.watch >= 0.5;
          if (!active) return;
          var data = stats.entry.data;
          items.push({
            id: key,
            label: data.label || null,
            pid: data.product ? data.product.id : null,
            product: data.product ? data.product.title : null,
            poster: stats.opens ? data.poster : null,
            opens: stats.opens,
            uopens: stats.uopens,
            watch: Math.round(stats.watch * 10) / 10,
            q25: stats.q25,
            q50: stats.q50,
            q75: stats.q75,
            done: stats.done,
            atc: stats.atc,
          });
        });
        if (!queue.imp && !queue.viewers && !items.length) return;

        var payload = {
          v: 1,
          page: this.dataset.page || 'other',
          dev: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
          imp: queue.imp,
          uimp: queue.uimp,
          viewers: queue.viewers,
          items: items,
        };
        this.queue = emptyQueue();
        this.dispatchEvent(new CustomEvent('casa:shoppable-video-stats', { bubbles: true, detail: payload }));
        if (!this.trackUrl) return;

        // Plain-text beacon: survives page unload and needs no CORS preflight.
        var body = JSON.stringify(payload);
        var sent = false;
        try {
          if (navigator.sendBeacon) sent = navigator.sendBeacon(this.trackUrl, body);
        } catch (error) {}
        if (!sent) {
          try {
            fetch(this.trackUrl, {
              method: 'POST',
              mode: 'no-cors',
              keepalive: true,
              headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
              body: body,
            }).catch(function () {});
          } catch (error) {}
        }
      }

      // Notes on the cart travel to the order, so orders can be matched to videos.
      noteOnCart(attributes) {
        fetch(shopRoot() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes }),
        }).catch(function () {});
      }

      markWatched() {
        if (this.dataset.tagOrders !== 'true' || this.inEditor || this.watchedNoted) return;
        this.watchedNoted = true;
        try {
          if (window.sessionStorage.getItem('casaShoppableVideoWatched')) return;
          window.sessionStorage.setItem('casaShoppableVideoWatched', '1');
        } catch (error) {}
        this.noteOnCart({ 'Video watched': 'Yes' });
      }

      /* ---------- Row of cards ---------- */

      bindRail() {
        var self = this;

        this.entries.forEach(function (entry, i) {
          entry.card.addEventListener('click', function () {
            self.open(i, entry.card);
          });
        });

        var arrows = this.querySelectorAll('[data-csv-scroll]');
        var updateArrows = function () {
          var rail = self.rail;
          var max = rail.scrollWidth - rail.clientWidth;
          arrows.forEach(function (arrow) {
            var forward = arrow.dataset.csvScroll === '1';
            arrow.hidden = forward ? rail.scrollLeft >= max - 4 : rail.scrollLeft <= 4;
          });
        };
        arrows.forEach(function (arrow) {
          arrow.addEventListener('click', function () {
            var step = self.rail.clientWidth * 0.8 * Number(arrow.dataset.csvScroll);
            self.rail.scrollBy({ left: step, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
          });
        });
        this.rail.addEventListener('scroll', updateArrows, { passive: true });
        this.onResize = updateArrows;
        window.addEventListener('resize', updateArrows);
        updateArrows();
      }

      setupPreviews() {
        var self = this;
        var connection = navigator.connection;
        if (reduceMotion.matches) return;
        if (connection && connection.saveData) return;
        if (!('IntersectionObserver' in window)) return;
        if (!this.querySelector('.csv-card__video')) return;

        this.entries.forEach(function (entry) {
          var video = entry.card.querySelector('.csv-card__video');
          if (!video) return;
          video.addEventListener('playing', function () {
            entry.card.classList.add('is-playing');
          });
        });

        this.previewObserver = new IntersectionObserver(
          function (changes) {
            changes.forEach(function (change) {
              var card = change.target;
              if (change.isIntersecting && change.intersectionRatio >= 0.6) {
                self.visible.add(card);
                if (!self.dialog.open) self.playPreview(card);
              } else {
                self.visible.delete(card);
                self.pausePreview(card);
              }
            });
          },
          { threshold: [0, 0.6] }
        );
        this.entries.forEach(function (entry) {
          self.previewObserver.observe(entry.card);
        });
      }

      playPreview(card) {
        var video = card.querySelector('.csv-card__video');
        if (!video) return;
        if (!video.getAttribute('src')) video.setAttribute('src', video.dataset.src);
        video.muted = true;
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
      }

      pausePreview(card) {
        var video = card.querySelector('.csv-card__video');
        if (video && !video.paused) video.pause();
      }

      /* ---------- Player ---------- */

      bindPlayer() {
        var self = this;
        var video = this.video;
        var single = this.entries.length < 2;

        this.prevBtn.hidden = single;
        this.nextBtn.hidden = single;

        this.prevBtn.addEventListener('click', function () { self.show(self.index - 1); });
        this.nextBtn.addEventListener('click', function () { self.show(self.index + 1); });
        this.querySelector('[data-csv-close]').addEventListener('click', function () { self.close(); });
        this.toggleBtn.addEventListener('click', function () { self.togglePlay(); });
        this.muteBtn.addEventListener('click', function () { self.setMuted(!self.muted); });
        video.addEventListener('click', function () { self.togglePlay(); });

        video.addEventListener('timeupdate', function () {
          var play = self.playState;
          if (play) {
            var step = play.last === null ? 0 : video.currentTime - play.last;
            if (step > 0 && step < 1.5) play.watch += step;
            play.last = video.currentTime;
            if (video.duration) play.max = Math.max(play.max, video.currentTime / video.duration);
          }
          if (!video.duration) return;
          self.bar.style.transform = 'scaleX(' + Math.min(video.currentTime / video.duration, 1) + ')';
        });
        video.addEventListener('playing', function () {
          if (!self.playState || self.playState.started) return;
          self.playState.started = true;
          self.markWatched();
        });
        video.addEventListener('loadedmetadata', function () {
          self.stage.classList.toggle('is-wide', video.videoWidth > video.videoHeight * 0.8);
        });
        video.addEventListener('play', function () { self.setPaused(false); });
        video.addEventListener('pause', function () {
          if (!video.ended) self.setPaused(true);
        });
        video.addEventListener('ended', function () {
          if (self.playState) self.playState.max = 1;
          if (!video.loop) self.show(self.index + 1);
        });

        // Clicking the soft background outside the video closes the player.
        this.dialog.addEventListener('click', function (event) {
          if (event.target === self.dialog || event.target.classList.contains('csv-player__frame')) self.close();
        });
        this.dialog.addEventListener('close', function () { self.onClose(); });

        this.dialog.addEventListener('keydown', function (event) {
          var tag = event.target.tagName;
          if (tag === 'SELECT' || tag === 'INPUT' || tag === 'TEXTAREA') return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            if (single) return;
            event.preventDefault();
            self.show(self.index + 1);
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            if (single) return;
            event.preventDefault();
            self.show(self.index - 1);
          } else if (event.key === ' ' && tag !== 'BUTTON' && tag !== 'A') {
            event.preventDefault();
            self.togglePlay();
          }
        });

        // Swipe up / left for the next video, down / right for the previous one.
        var startX = 0;
        var startY = 0;
        var tracking = false;
        this.stage.addEventListener(
          'touchstart',
          function (event) {
            tracking = event.target === video && event.touches.length === 1;
            if (!tracking) return;
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
          },
          { passive: true }
        );
        this.stage.addEventListener(
          'touchend',
          function (event) {
            if (!tracking || single) return;
            tracking = false;
            var dx = event.changedTouches[0].clientX - startX;
            var dy = event.changedTouches[0].clientY - startY;
            var distance = Math.abs(dx) > Math.abs(dy) ? dx : dy;
            if (Math.abs(distance) < 50) return;
            event.preventDefault();
            self.show(self.index + (distance < 0 ? 1 : -1));
          },
          { passive: false }
        );

        this.selectEl.addEventListener('change', function () { self.updateVariant(); });
        this.addBtn.addEventListener('click', function () { self.addToCart(); });
      }

      open(index, trigger) {
        this.lastTrigger = trigger;
        this.entries.forEach(function (entry) {
          var preview = entry.card.querySelector('.csv-card__video');
          if (preview && !preview.paused) preview.pause();
        });
        if (!this.dialog.open) {
          if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
          else this.dialog.setAttribute('open', '');
        }
        document.documentElement.classList.add('csv-lock');
        this.show(index);
        this.track('open', this.entries[this.index]);
      }

      close() {
        if (!this.dialog.open) return;
        if (typeof this.dialog.close === 'function') this.dialog.close();
        else {
          this.dialog.removeAttribute('open');
          this.onClose();
        }
      }

      onClose() {
        var self = this;
        this.harvest();
        this.playState = null;
        this.flush();
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.load();
        document.documentElement.classList.remove('csv-lock');
        this.visible.forEach(function (card) { self.playPreview(card); });
        if (this.lastTrigger && document.contains(this.lastTrigger)) {
          this.lastTrigger.focus({ preventScroll: true });
        }
      }

      show(index) {
        var count = this.entries.length;
        this.index = ((index % count) + count) % count;
        var data = this.entries[this.index].data;
        var video = this.video;

        this.startPlay();
        this.stage.classList.remove('is-wide');
        this.bar.style.transform = 'scaleX(0)';
        if (data.poster) video.setAttribute('poster', data.poster);
        else video.removeAttribute('poster');
        video.loop = count === 1 || this.dataset.advance !== 'true';
        video.src = data.video;
        this.setMuted(this.muted);

        this.captionEl.textContent = data.caption || '';
        this.captionEl.hidden = !data.caption;
        this.renderProduct(data.product);
        this.play();
      }

      play() {
        var self = this;
        var video = this.video;
        var attempt = video.play();
        if (!attempt || !attempt.catch) return;
        attempt.catch(function (error) {
          // Browsers may block sound until the shopper interacts: retry muted.
          if (error && error.name === 'NotAllowedError' && !video.muted) {
            self.setMuted(true);
            var retry = video.play();
            if (retry && retry.catch) retry.catch(function () { self.setPaused(true); });
          } else if (error && error.name !== 'AbortError') {
            self.setPaused(true);
          }
        });
      }

      togglePlay() {
        if (this.video.paused) this.play();
        else this.video.pause();
      }

      setPaused(paused) {
        this.stage.classList.toggle('is-paused', paused);
        this.toggleBtn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      }

      setMuted(muted) {
        this.muted = muted;
        this.video.muted = muted;
        this.muteBtn.setAttribute('aria-pressed', String(muted));
        this.muteBtn.setAttribute('aria-label', muted ? 'Turn sound on' : 'Mute sound');
      }

      /* ---------- Product card and cart ---------- */

      renderProduct(product) {
        var self = this;
        this.product = product;
        this.panel.hidden = !product;
        this.setStatus('', false, false);
        if (!product) return;

        this.titleEl.textContent = product.title;
        this.linkEl.href = product.url;
        this.linkEl.hidden = !!product.current;

        if (product.image) this.imgEl.src = product.image;
        this.imgEl.hidden = !product.image;
        this.panel.classList.toggle('csv-panel--no-img', !product.image);

        var soldOut = this.dataset.labelSoldOut || 'Sold out';
        var firstAvailable = null;
        this.selectEl.textContent = '';
        product.variants.forEach(function (variant) {
          var option = document.createElement('option');
          option.value = String(variant.id);
          option.textContent = variant.available ? variant.title : variant.title + ' - ' + soldOut;
          option.disabled = !variant.available;
          self.selectEl.appendChild(option);
          if (variant.available && firstAvailable === null) firstAvailable = variant;
        });
        this.selectEl.hidden = product.variants.length < 2;
        if (firstAvailable) this.selectEl.value = String(firstAvailable.id);
        else if (product.variants.length) this.selectEl.selectedIndex = 0;

        this.updateVariant();
      }

      currentVariant() {
        if (!this.product) return null;
        var id = this.selectEl.value;
        var variants = this.product.variants;
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === id) return variants[i];
        }
        return variants[0] || null;
      }

      updateVariant() {
        var variant = this.currentVariant();
        var available = !!(variant && variant.available);
        this.priceEl.textContent = variant ? variant.price : '';
        this.compareEl.textContent = variant && variant.compare ? variant.compare : '';
        this.compareEl.hidden = !(variant && variant.compare);
        this.addBtn.disabled = !available;
        this.addBtn.textContent = available
          ? this.dataset.labelAdd || 'Add to cart'
          : this.dataset.labelSoldOut || 'Sold out';
      }

      setStatus(message, showCartLink, isError) {
        this.statusText.textContent = message;
        this.statusEl.hidden = !message;
        this.cartLink.hidden = !showCartLink;
        this.statusEl.classList.toggle('is-error', !!isError);
      }

      addToCart() {
        var self = this;
        var variant = this.currentVariant();
        var entry = this.entries[this.index];
        if (!variant || !variant.available || this.busy) return;

        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var sections = ['cart-icon-bubble'];
        if (cart && typeof cart.getSectionsToRender === 'function') {
          sections = cart.getSectionsToRender().map(function (section) { return section.id; });
        }
        var root = shopRoot();

        this.busy = true;
        this.addBtn.setAttribute('aria-busy', 'true');
        this.setStatus('', false, false);

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            id: variant.id,
            quantity: 1,
            sections: sections.slice(0, 5),
            sections_url: window.location.pathname,
          }),
        })
          .then(function (response) {
            return response.json().then(function (json) {
              if (!response.ok || json.status) {
                throw new Error(json.description || json.message || 'Could not add this item. Please try again.');
              }
              return json;
            });
          })
          .then(function (json) {
            self.track('add_to_cart', entry);
            self.tagOrder(entry);
            self.statsFor(entry).atc += 1;
            self.harvest();
            self.flush();

            if (self.dataset.afterAdd === 'cart') {
              self.close();
              try {
                if (!cart || typeof cart.renderContents !== 'function') throw new Error('no cart element');
                if (typeof cart.setActiveElement === 'function') cart.setActiveElement(self.lastTrigger);
                cart.renderContents(json);
              } catch (error) {
                window.location.assign(self.dataset.cartUrl || '/cart');
                return;
              }
            } else {
              self.refreshCart(json.sections);
              self.setStatus(self.dataset.labelAdded || 'Added to cart', true, false);
            }

            // Let the rest of the theme know the cart changed (Dawn pub/sub).
            try {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'casa-shoppable-videos',
                  productVariantId: variant.id,
                  cartData: json,
                });
              }
            } catch (error) {}
          })
          .catch(function (error) {
            self.setStatus(error.message, false, true);
          })
          .then(function () {
            self.busy = false;
            self.addBtn.removeAttribute('aria-busy');
          });
      }

      // Updates the header cart count and the cart drawer without opening it.
      refreshCart(sections) {
        if (!sections) return;

        if (sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          var freshBubble = parseHTML(sections['cart-icon-bubble']).querySelector('.shopify-section');
          if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
        }

        var drawer = document.querySelector('cart-drawer');
        if (drawer && sections['cart-drawer']) {
          var inner = document.getElementById('CartDrawer');
          var freshInner = parseHTML(sections['cart-drawer']).querySelector('#CartDrawer');
          if (inner && freshInner) {
            inner.innerHTML = freshInner.innerHTML;
            drawer.classList.remove('is-empty');
            var overlay = drawer.querySelector('#CartDrawer-Overlay');
            if (overlay && typeof drawer.close === 'function') {
              overlay.addEventListener('click', function () { drawer.close(); });
            }
          }
        }
      }

      // Saves "Shoppable video: <products>" on the order (Additional details),
      // so orders that came through a video can be counted later.
      tagOrder(entry) {
        if (this.dataset.tagOrders !== 'true' || !entry.data.product) return;
        var key = 'casaShoppableVideoAdds';
        var titles = [];
        try {
          titles = JSON.parse(window.sessionStorage.getItem(key) || '[]');
        } catch (error) {}
        // No commas: the note is later copied into a comma-separated sheet row.
        var title = String(entry.data.product.title).replace(/[,|]/g, ' ').replace(/\s+/g, ' ').trim();
        if (titles.indexOf(title) === -1) titles.push(title);
        try {
          window.sessionStorage.setItem(key, JSON.stringify(titles));
        } catch (error) {}
        this.noteOnCart({ 'Video watched': 'Yes', 'Shoppable video': titles.join(' | ').slice(0, 240) });
      }

      // Fires events you can pick up in Shopify "Customer events" pixels.
      track(action, entry) {
        var product = entry && entry.data.product;
        var detail = {
          action: action,
          section: this.id,
          product_id: product ? product.id : null,
          product_title: product ? product.title : null,
          video_url: entry ? entry.data.video : null,
        };
        this.dispatchEvent(new CustomEvent('casa:shoppable-video', { bubbles: true, detail: detail }));
        try {
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            window.Shopify.analytics.publish('shoppable_video_' + action, detail);
          }
        } catch (error) {}
      }
    }

    customElements.define('casa-shoppable-videos', CasaShoppableVideos);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
